"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
class SingleItem {
    constructor(item) {
        this.$item = item;
    }
    render() {
        return `<div class="col-xl-3 col-lg-4 col-md-6 col-sm-6 col-12">
                    <div class="post-card">
                        ${this.thumbnail()}
                        <div class="post-title">
                            <a target="_blank" href="${lodash_1.default.get(this.$item, 'url.base')}">${lodash_1.default.get(this.$item, 'title')}</a>
                            ${this.date()}
                        </div>
                    </div>
                </div>
            `;
    }
    date() {
        return `
            <span class="post-date">${lodash_1.default.get(this.$item, 'created_at')}</span>
        `;
    }
    thumbnail() {
        const photo = lodash_1.default.get(this.$item, 'cover') || { url: '/static/images/none-picture.jpg', alt: 'img-loading' };
        return `<div class="post-thumbnail">
                    <a target="_blank" href="${lodash_1.default.get(this.$item, 'url.base')}">
                        <img loading="lazy" src="${lodash_1.default.get(photo, 'url')}" alt="${lodash_1.default.get(photo, 'alt')}">
                    </a>
                    <span class="post-tag">مقاله</span>
                </div>`;
    }
}
exports.default = SingleItem;
